import { usePageContext } from "../context/pageContext";
import { selectOffer } from "./selectOffer";
import { PLAYBOOKS } from "./registry";
import { getDismissed, isMuted } from "./offerPrefs";
import type { Offer, Playbook } from "./types";

/**
 * The offer to show right now, or null.
 *
 * An offer lives exactly as long as the page it is about: it appears when the
 * snapshot matches a playbook and goes when it stops matching. Dismissing one
 * silences it for the session; the Settings toggle silences all of them.
 *
 * There is deliberately no "already shown" budget on top of that -- see
 * offerPrefs for why it was removed.
 */
export function useOffer(playbooks: Playbook[] = PLAYBOOKS): Offer | null {
  const snapshot = usePageContext();
  if (isMuted()) return null;
  return selectOffer(snapshot, getDismissed(), playbooks);
}
